<template>
  <div>
    <a-dropdown
      v-if="currentUser && currentUser.userName"
      placement="bottomCenter"
      v-model="dropdownVisible"
    >
      <span class="ant-pro-account-avatar">
        <a-avatar
          size="small"
          style="background-color: #0e68cb; margin-top: -4px"
          shape="square"
          >{{ currentUser.accountType === 5 ? "个人" : "企业" }}</a-avatar
        >
        <span class="user-wrapper">
          <span class="user-name">{{ currentUser.userName }}</span>
          <a-icon
            type="down"
            :class="['arrow-icon', { rotate: dropdownVisible }]"
          />
        </span>
      </span>

      <template v-slot:overlay>
        <a-menu class="ant-pro-drop-down menu">
          <a-menu-item key="center" @click="handleToCenter">
            <span style="display: inline-flex; align-items: center">
              <span style="display: inline-flex; align-items: center">
                <a-icon type="user" style="margin-right: 6px" />
                个人中心
              </span>
            </span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item-group title="账号切换" v-if="accountList.length !== 0">
            <a-menu-item
              v-for="account in accountList"
              :key="account.accountId"
              class="switch-item"
              :class="{ active: account.accountId === currentUser.accountId }"
              :disabled="
                account.accountId === currentUser.accountId ||
                switchingAccountId !== null
              "
              @click="selectAccount(account)"
            >
              <a-avatar
                size="small"
                shape="square"
                :style="{
                  backgroundColor: '#0060c9',
                }"
              >
                {{ account.accountType === 5 ? "个人" : "企业" }}
              </a-avatar>
              <span class="switch-name" style="margin-left: 4px">
                {{ account.userName }}
              </span>
              <a-icon
                v-if="account.accountId === switchingAccountId"
                type="loading"
                class="check-icon"
              />
              <a-icon
                v-else-if="account.accountId === currentUser.accountId"
                type="check"
                class="check-icon"
              />
            </a-menu-item>
          </a-menu-item-group>

          <a-spin
            size="small"
            v-if="accountList.length === 0"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 4px 0;
            "
          />

          <a-menu-divider />
          <a-menu-item key="logout" @click="handleLogout">
            <span style="display: inline-flex; align-items: center">
              <a-icon type="logout" style="margin-right: 7px" />
              登出
            </span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>
    <a-modal
      :width="450"
      :footer="null"
      :visible="switchVisible"
      :closable="false"
      :maskClosable="false"
      :zIndex="999"
      @cancel="closeSwitchMoudle"
      destroyOnClose
    >
      <SwitchAccount
        :switch-account="switchAccount"
        @closeSwitchMoudle="closeSwitchMoudle()"
        @forgetPassword="openEnterprisePasswordReset"
      />
    </a-modal>
    <a-modal
      :width="620"
      :footer="null"
      :visible="enterprisePasswordResetVisible"
      :maskClosable="false"
      :zIndex="1000"
      title="重置企业切换密码"
      destroyOnClose
      @cancel="closeEnterprisePasswordReset"
    >
      <EnterprisePasswordReset
        :key="enterprisePasswordResetKey"
        :switch-account="switchAccount"
        @cancel="closeEnterprisePasswordReset"
        @completed="completeEnterprisePasswordReset"
      />
    </a-modal>
  </div>
</template>

<script>

import { Modal } from "ant-design-vue";
import store from "@/store";
import storage from "store";
import { resetRouter } from "@/router";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { timeFix } from "@/utils/util";
import { listSwitchAccount } from "@/api/user/login/Login.js";
import { listBindCompany } from "@/api/company/Company.js";
import SwitchAccount from "./SwitchAccount.vue";
import EnterprisePasswordReset from "./EnterprisePasswordReset.vue";

export default {
  name: "AvatarDropdown",
  components: {
    SwitchAccount,
    EnterprisePasswordReset,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      accountList: [],
      dropdownVisible: false,
      switchVisible: false,
      enterprisePasswordResetVisible: false,
      enterprisePasswordResetKey: 0,
      switchAccount: {},
      switchingAccountId: null,
    };
  },
  watch: {
    // 当鼠标移到用户名或头像出，触发，箭头向下，展开下拉框
    dropdownVisible(val) {
      if (val) {
        this.handleVisibleChange(); // 展开时刷新账号列表
      }
    },
  },
  methods: {


    handleVisibleChange() {
      this.accountList = [];
      listBindCompany()
        .catch(() => null)
        .then(() => listSwitchAccount())
        .then((res) => {
          if (res.code == "200") {
            this.accountList = res.data;
          } else {
            this.$notification["error"]({
              message: "错误",
              description: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "错误",
            description: "网络异常，请稍后再试",
            duration: 4,
          });
        });
    },
    handleToCenter() {
      this.$router.push({ path: "/personalCenter" });
    },
    handleLogout() {
      Modal.confirm({
        title: "信息",
        content: "您确定要注销吗？",
        onOk: () => {
          return store.dispatch("Logout").then(() => {
            resetRouter();
            this.$router.push({ name: "login" });
          }).catch((error) => {
            const response = (error || {}).response || {};
            const responseData = response.data || {};
            if (response.status !== 503) {
              this.$notification.error({
                message: "退出失败",
                description: responseData.msg || "请稍后重试",
              });
            }
            return Promise.reject(error);
          });
        },
        onCancel() {},
      });
    },
    selectAccount(account) {
      if (this.switchingAccountId !== null) {
        return;
      }
      if (Number(account.accountType) === 5) {
        this.dropdownVisible = false;
        this.switchToPersonalAccount(account);
        return;
      }
      this.switchAccount = account;
      this.switchVisible = true;
    },
    switchToPersonalAccount(account) {
      this.switchingAccountId = account.accountId;
      store
        .dispatch("SwitchAccount", {
          switchAccountId: account.accountId,
          switchPassword: null,
        })
        .then((res) => {
          if (res.code != "200") {
            this.switchingAccountId = null;
            this.$notification.error({
              message: "错误",
              description: res.msg,
            });
            return;
          }

          store.commit("SET_TOKEN", "");
          store.commit("SET_ACCOUNT_TYPE", "");
          store.commit("SET_ACCOUNT_ID", "");
          store.commit("SET_USER_NAME", "");
          storage.remove(ACCESS_TOKEN);
          storage.set(ACCESS_TOKEN, res.token, 12 * 60 * 60 * 1000);
          store.commit("SET_TOKEN", res.token);

          setTimeout(() => {
            this.$notification.success({
              message: "账号切换成功",
              description: `${timeFix()}，欢迎回来`,
            });
          }, 300);
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        })
        .catch((err) => {
          this.switchingAccountId = null;
          const responseData = ((err || {}).response || {}).data || {};
          this.$notification.error({
            message: "错误",
            description:
              responseData.msg ||
              responseData.message ||
              "网络异常，请稍后再试",
            duration: 4,
          });
        });
    },
    closeSwitchMoudle() {
      this.switchVisible = false;
    },
    openEnterprisePasswordReset(account) {
      if (account && account.accountId) {
        this.switchAccount = account;
      }
      this.switchVisible = false;
      this.enterprisePasswordResetKey += 1;
      this.enterprisePasswordResetVisible = true;
    },
    closeEnterprisePasswordReset() {
      this.enterprisePasswordResetVisible = false;
      this.$nextTick(() => {
        this.switchVisible = true;
      });
    },
    completeEnterprisePasswordReset() {
      this.enterprisePasswordResetVisible = false;
      this.$nextTick(() => {
        this.switchVisible = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
.switch-item {
  display: flex;
  align-items: center;
  padding: 4px 2px; /* ✅ 整体左右留2px */
  box-sizing: border-box;

  .ant-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 12px;
    width: 24px;
    height: 24px;
    margin-right: 4px; /* ✅ 头像和文字留一点空隙 */
  }

  .switch-name {
    flex: 1;
    font-size: 13px;
    margin: 0 2px; /* ✅ 名称两边各留2px */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .check-icon {
    margin: 0 2px; /* ✅ 对勾与右边留2px */
    font-size: 12px;
  }

  &.active {
    font-weight: 600;
  }
}
.arrow-icon {
  margin-left: 4px;
  transition: transform 0.25s ease;
  vertical-align: middle;
}

.arrow-icon.rotate {
  transform: rotate(180deg);
}
.user-wrapper {
  display: inline-flex;
  align-items: center;
  max-width: 250px; /* ← 根据你的右侧布局宽度调整 */
  white-space: nowrap;
  overflow: hidden;
}

.user-name {
  font-size: 14px;
  font-weight: bold;
  font-family: Arial;
  margin-left: 6px;
  display: inline-block;
  max-width: 200px; /* ← 文本允许的最大宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
